import {
  ExceptionCode,
  LoadingStatusType,
  PndErrorCode,
  PndStatus,
  PndTableViewStatusType,
  PndType,
  TransactionType,
  TypeComponentNoti,
} from "@/enums/enums";
import {
  ConvertToInsertPnd,
  SetHeaderPndTable,
  SetHeadertWhtCertificateTableByPeriodTaxTable,
  SetTapsPndTable,
} from "@/helper/pndHelper";
import { DownloadFileFormUrl, GetMessageExceptionCode } from "@/helper/shareHelper";
import { MerchantId } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import router from "@/router";
import API from "@/service/Index";
import {
  ConvertToClosingEntryPndModelFromMongo,
  ConvertToPndDetailById,
  ConvertToUpdateIsFiledPnd,
  ConvertToWhtCertificateTable,
} from "@/service/pnd/pndFacade";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Pnd extends VuexModule {
  public pndByTaxPeriodModelListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public pndByTaxPeriodModelList: any | null = null;
  public whtCertificateTableByPeriodTaxLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public whtCertificateTableByPeriodTax: any | null = null;
  public whtCertificateTableByPndIdLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public whtCertificateTableByPndId: any | null = null;
  public whtCertificateTableByPeriodTaxForAddNewLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public whtCertificateTableByPeriodTaxForAddNew: any | null = null;
  public headerWhtCertificateTableByPeriodTax: any | null = null;
  public headerWhtCertificateTableByPeriodTaxForAddNew: any | null = null;
  public pndByTaxPeriodOnchangeStatus = false;
  public pndCreateTemplate: any | null = null;
  public pndByTaxPeriodOnchangeLoadingStatus = false;
  public pndTableList: any = null;
  public headerPndTable: any = [];
  public pndTableTaps: any = null;
  public pndTableLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public insertPndLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public pndDetailById: any = null;
  public pndDetailByIdLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public updatePndLoadingstatus: LoadingStatusType = LoadingStatusType.None;
  public voidPndLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public updateIsFiledPndLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public isFiledPndModelFromMongoLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public isFiledPndModelFromMongoDetail: any = null;
  public updateIsClosingEntryPndLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public updateIsPaidPndLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public closingEntryPndModelFromMongo: any = null;
  public closingEntryPndModelFromMongoLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public createExpenseByIsClosingEntryPndLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public isOpenModalCheckTextFileForFiledPnd = false;
  public voidIsClosingEntryPndExpenseLoadingStatusType: LoadingStatusType = LoadingStatusType.None;
  public voidIsClosingEntryPndJournalLoadingStatusType: LoadingStatusType = LoadingStatusType.None;

  get getIsOpenModalCheckTextFileForFiledPnd(): boolean {
    return this.isOpenModalCheckTextFileForFiledPnd;
  }
  get getPndByTaxPeriodModelListLoadingStatus(): LoadingStatusType {
    return this.pndByTaxPeriodModelListLoadingStatus;
  }
  get getPndByTaxPeriodModelList(): any {
    return this.pndByTaxPeriodModelList;
  }
  get getWhtCertificateTableByPeriodTaxLoadingStatus(): LoadingStatusType {
    return this.whtCertificateTableByPeriodTaxLoadingStatus;
  }
  get getWhtCertificateTableByPeriodTax(): any {
    return this.whtCertificateTableByPeriodTax;
  }
  get getWhtCertificateTableByPeriodForAddNewTaxLoadingStatus(): LoadingStatusType {
    return this.whtCertificateTableByPeriodTaxForAddNewLoadingStatus;
  }
  get getWhtCertificateTableByPeriodTaxForAddNew(): any {
    return this.whtCertificateTableByPeriodTaxForAddNew;
  }
  get getHeaderWhtCertificateTableByPeriodTax(): any {
    return this.headerWhtCertificateTableByPeriodTax;
  }
  get getHeaderWhtCertificateTableByPeriodTaxForAddNew(): any {
    return this.headerWhtCertificateTableByPeriodTaxForAddNew;
  }
  get getPndByTaxPeriodOnchangeStatus(): boolean {
    return this.pndByTaxPeriodOnchangeStatus;
  }
  get getPndTableList(): any {
    return this.pndTableList;
  }
  get getHeaderPndTable(): any {
    return this.headerPndTable;
  }
  get getPndTableTaps(): any {
    return this.pndTableTaps;
  }
  get getPndTableLoadingStatus(): LoadingStatusType {
    return this.pndTableLoadingStatus;
  }
  get getInsertPndLoadingStatus(): LoadingStatusType {
    return this.insertPndLoadingStatus;
  }
  get getPndDetailByIdLoadingStatus(): LoadingStatusType {
    return this.pndDetailByIdLoadingStatus;
  }
  get getPndDetailById(): any {
    return this.pndDetailById;
  }
  get getWhtCertificateTableByPndIdLoadingStatus(): LoadingStatusType {
    return this.whtCertificateTableByPndIdLoadingStatus;
  }
  get getWhtCertificateTableByPndId(): any {
    return this.whtCertificateTableByPndId;
  }
  get getUpdatePndLoadingstatus(): LoadingStatusType {
    return this.updatePndLoadingstatus;
  }
  get getVoidPndLoadingStatus(): LoadingStatusType {
    return this.voidPndLoadingStatus;
  }
  get getUpdateIsFiledPndLoadingStatus(): LoadingStatusType {
    return this.updateIsFiledPndLoadingStatus;
  }
  get getIsFiledPndModelFromMongoLoadingStatus(): LoadingStatusType {
    return this.isFiledPndModelFromMongoLoadingStatus;
  }
  get getIsFiledPndModelFromMongoDetail(): any {
    return this.isFiledPndModelFromMongoDetail;
  }
  get getUpdateIsClosingEntryPndLoadingStatus(): LoadingStatusType {
    return this.updateIsClosingEntryPndLoadingStatus;
  }
  get getUpdateIsPaidPndLoadingStatus(): LoadingStatusType {
    return this.updateIsPaidPndLoadingStatus;
  }
  get getClosingEntryPndModelFromMongo(): any {
    return this.closingEntryPndModelFromMongo;
  }
  get getClosingEntryPndModelFromMongoLoadingStatus(): LoadingStatusType {
    return this.closingEntryPndModelFromMongoLoadingStatus;
  }
  get getCreateExpenseByIsClosingEntryPndLoadingStatus(): LoadingStatusType {
    return this.createExpenseByIsClosingEntryPndLoadingStatus;
  }
  get getVoidIsClosingEntryPndExpenseLoadingStatusType(): LoadingStatusType {
    return this.voidIsClosingEntryPndExpenseLoadingStatusType;
  }
  get getVoidIsClosingEntryPndJournalLoadingStatusType(): LoadingStatusType {
    return this.voidIsClosingEntryPndJournalLoadingStatusType;
  }

  @Mutation
  public SetPndByTaxPeriodModelListLoadingStatus(status: LoadingStatusType) {
    this.pndByTaxPeriodModelListLoadingStatus = status;
  }
  @Mutation
  public SetPndByTaxPeriodModelList(pndByTaxPeriodModelList: any) {
    this.pndByTaxPeriodModelList = pndByTaxPeriodModelList;
  }
  @Mutation
  public SetWhtCertificateTableByPeriodTaxLoadingStatus(status: LoadingStatusType) {
    this.whtCertificateTableByPeriodTaxLoadingStatus = status;
  }
  @Mutation
  public SetWhtCertificateTableByPeriodTax(whtCertificateTableByPeriodTax: any) {
    this.whtCertificateTableByPeriodTax = whtCertificateTableByPeriodTax;
    this.headerWhtCertificateTableByPeriodTax = SetHeadertWhtCertificateTableByPeriodTaxTable();
  }
  @Mutation
  public SetWhtCertificateTableByPeriodTaxForAddNewLoadingStatus(status: LoadingStatusType) {
    this.whtCertificateTableByPeriodTaxForAddNewLoadingStatus = status;
  }
  @Mutation
  public SetWhtCertificateTableByPeriodTaxForAddNew(whtCertificateTableByPeriodTax: any) {
    this.whtCertificateTableByPeriodTaxForAddNew = whtCertificateTableByPeriodTax;
    this.headerWhtCertificateTableByPeriodTaxForAddNew = SetHeadertWhtCertificateTableByPeriodTaxTable(true);
  }
  @Mutation
  public SetPndByTaxPeriodOnchangeStatus(status: boolean) {
    this.pndByTaxPeriodOnchangeStatus = status;
  }

  @Mutation
  public SetPndTableLoadingStatus(status: LoadingStatusType) {
    this.pndTableLoadingStatus = status;
  }

  @Mutation
  public SetPndTable(input: any) {
    this.pndTableTaps = SetTapsPndTable(input.data.tableView, input.data.countPnd);
    this.pndTableList = input.data.pndTableDetailModelList;
  }

  @Mutation
  public SetIsOpenModalCheckTextFileForFiledPnd(input: boolean) {
    this.isOpenModalCheckTextFileForFiledPnd = input;
  }

  @Mutation
  public SetHeaderPndTable(input: any) {
    this.headerPndTable = SetHeaderPndTable();

    if (input.sorting !== null) {
      this.headerPndTable.forEach((item: any) => {
        if (item.sortBy == input.sortBy) {
          item.sortingType = input.sortingType;
        } else {
          item.sortingType = null;
        }
      });
    }
  }

  @Mutation
  public SetInsertPndLoadingStatus(status: LoadingStatusType) {
    this.insertPndLoadingStatus = status;
  }

  @Mutation
  public SetPndDetailByIdLoadingStatus(status: LoadingStatusType) {
    this.pndDetailByIdLoadingStatus = status;
  }
  @Mutation
  public SetPndDetailById(pndDetailById: any) {
    this.pndDetailById = pndDetailById;
  }

  @Mutation
  public SetWhtCertificateTableByPndIdLoadingStatus(status: LoadingStatusType) {
    this.whtCertificateTableByPndIdLoadingStatus = status;
  }
  @Mutation
  public SetWhtCertificateTableByPndId(whtCertificateTableByPndId: any) {
    this.whtCertificateTableByPndId = whtCertificateTableByPndId;
    this.headerWhtCertificateTableByPeriodTax = SetHeadertWhtCertificateTableByPeriodTaxTable();
  }

  @Mutation
  public SetUpdatePndLoadingstatus(status: LoadingStatusType) {
    this.updatePndLoadingstatus = status;
  }

  @Mutation
  public SetVoidPndLoadingStatus(status: LoadingStatusType) {
    this.voidPndLoadingStatus = status;
  }

  @Mutation
  public SetUpdateIsFiledPndLoadingStatus(status: LoadingStatusType) {
    this.updateIsFiledPndLoadingStatus = status;
  }
  @Mutation
  public SetIsFiledPndModelFromMongoLoadingStatus(status: LoadingStatusType) {
    this.isFiledPndModelFromMongoLoadingStatus = status;
  }
  @Mutation
  public SetIsFiledPndModelFromMongoDetail(IsFiledPndModel: any) {
    this.isFiledPndModelFromMongoDetail = IsFiledPndModel;
  }
  @Mutation
  public SetUpdateIsClosingEntryPndLoadingStatus(status: LoadingStatusType) {
    this.updateIsClosingEntryPndLoadingStatus = status;
  }

  @Mutation
  public SetUpdateIsPaidPndLoadingStatus(status: LoadingStatusType) {
    this.updateIsPaidPndLoadingStatus = status;
  }

  @Mutation
  public SetClosingEntryPndModelFromMongo(_closingEntryPndModelFromMongo: any) {
    this.closingEntryPndModelFromMongo = _closingEntryPndModelFromMongo;
  }

  @Mutation
  public SetClosingEntryPndModelFromMongoLoadingStatus(status: LoadingStatusType) {
    this.closingEntryPndModelFromMongoLoadingStatus = status;
  }

  @Mutation
  public SetCreateExpenseByIsClosingEntryPndLoadingStatus(status: LoadingStatusType) {
    this.createExpenseByIsClosingEntryPndLoadingStatus = status;
  }

  @Mutation
  public SetVoidIsClosingEntryPndExpenseLoadingStatusType(status: LoadingStatusType) {
    this.voidIsClosingEntryPndExpenseLoadingStatusType = status;
  }

  @Mutation
  public SetVoidIsClosingEntryPndJournalLoadingStatusType(status: LoadingStatusType) {
    this.voidIsClosingEntryPndJournalLoadingStatusType = status;
  }

  @Action
  public DoGetPndByTaxPeriodModelList(input: any) {
    if (this.pndByTaxPeriodModelListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetPndByTaxPeriodModelListLoadingStatus", LoadingStatusType.Loading);
      API.PndService.GetPndByTaxPeriodModelList(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("SetPndByTaxPeriodModelList", res.data.data);
        }
        this.context.commit("SetPndByTaxPeriodModelListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetWhtCertificateTableByPeriodTax(input: any) {
    if (this.whtCertificateTableByPeriodTaxLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetWhtCertificateTableByPeriodTaxLoadingStatus", LoadingStatusType.Loading);
      API.PndService.GetWhtCertificateTableByPeriodTax(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const whtCertificateTable = ConvertToWhtCertificateTable(res.data.data);
          this.context.commit("SetWhtCertificateTableByPeriodTax", whtCertificateTable);
        }
        this.context.commit("SetWhtCertificateTableByPeriodTaxLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetWhtCertificateTableByPndId(input: any) {
    if (this.whtCertificateTableByPndIdLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetWhtCertificateTableByPndIdLoadingStatus", LoadingStatusType.Loading);
      API.PndService.GetWhtCertificateTableByPndId(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const whtCertificateTable = ConvertToWhtCertificateTable(res.data.data);
          this.context.commit("SetWhtCertificateTableByPndId", whtCertificateTable);
        }
        this.context.commit("SetWhtCertificateTableByPndIdLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetWhtCertificateTableByPeriodTaxForAddNew(input: any) {
    if (this.whtCertificateTableByPeriodTaxForAddNewLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetWhtCertificateTableByPeriodTaxForAddNewLoadingStatus", LoadingStatusType.Loading);
      API.PndService.GetWhtCertificateTableByPeriodTax(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const whtCertificateTable = ConvertToWhtCertificateTable(res.data.data);
          this.context.commit("SetWhtCertificateTableByPeriodTaxForAddNew", whtCertificateTable);
        }
        this.context.commit("SetWhtCertificateTableByPeriodTaxForAddNewLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoSetWhtCertificateTableByPeriodTaxLoadingStatus(status: LoadingStatusType) {
    this.context.commit("SetWhtCertificateTableByPeriodTaxLoadingStatus", status);
  }
  @Action
  public DoSetWhtCertificateTableByByPndIdLoadingStatus(status: LoadingStatusType) {
    this.context.commit("SetWhtCertificateTableByPndIdLoadingStatus", status);
  }
  @Action
  public DoSetPndByTaxPeriodOnchangeStatus(status: boolean) {
    this.context.commit("SetPndByTaxPeriodOnchangeStatus", status);
  }
  @Action
  public DoGetPndTable(input: any) {
    if (this.pndTableLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetPndTableLoadingStatus", LoadingStatusType.Loading);
      API.PndService.GetPndTable(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const tablePnd = {
            data: res.data.data,
            tableView: input.transactionTableViewStatusType,
          };
          const headerTablePnd = {
            sortBy: input.pndTableSortColumnType,
            sortingType: input.tableSortType,
          };
          this.context.commit("SetPndTable", tablePnd);
          this.context.commit("SetHeaderPndTable", headerTablePnd);
        }
        this.context.commit("SetPndTableLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetPndTableAdvanceSearch(input: any) {
    if (this.pndTableLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetPndTableLoadingStatus", LoadingStatusType.Loading);
      API.PndService.GetPndTableAdvanceSearch(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const tablePnd = {
            data: res.data.data,
            tableView: input.transactionTableViewStatusType,
          };
          const headerTablePnd = {
            sortBy: input.pndTableSortColumnType,
            sortingType: input.tableSortType,
          };
          this.context.commit("SetPndTable", tablePnd);
          this.context.commit("SetHeaderPndTable", headerTablePnd);
        }
        this.context.commit("SetPndTableLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoInsertPnd(input: any) {
    if (this.insertPndLoadingStatus !== LoadingStatusType.Loading) {
      const insertPnd = ConvertToInsertPnd(input);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetInsertPndLoadingStatus", LoadingStatusType.Loading);
      API.PndService.InsertPnd(insertPnd).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          let linkName = "";
          let linkDetailName = "";
          let pndType = 0;
          let alertMessage = "";

          switch (input.pndType) {
            case PndType.PND1:
              linkName = "pnd1";
              linkDetailName = "pnd1Detail";
              alertMessage = "Created_PND1_Success";
              pndType = PndType.PND1;
              break;
            case PndType.PND2:
              linkName = "pnd2";
              linkDetailName = "pnd2Detail";
              alertMessage = "Created_PND2_Success";
              pndType = PndType.PND2;
              break;
            case PndType.PND3:
              linkName = "pnd3";
              linkDetailName = "pnd3Detail";
              alertMessage = "Created_PND3_Success";
              pndType = PndType.PND3;
              break;
            case PndType.PND53:
              linkName = "pnd53";
              linkDetailName = "pnd53Detail";
              alertMessage = "Created_PND53_Success";
              pndType = PndType.PND53;
              break;
          }

          if (input.status < PndStatus.AwaitFiling) {
            router.push({
              name: linkName,
              query: { emi: MerchantId().PeakEncryption(), epti: btoa(pndType.toString()) },
            });
          } else {
            router.push({
              name: linkDetailName,
              query: {
                emi: MerchantId().PeakEncryption(),
                epti: btoa(pndType.toString()),
                epi: btoa(res.data.data.id.toString()),
              },
            });
          }
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t(alertMessage, { msg: res.data.data.pndNumber }),
              typeMessage: TypeComponentNoti.success,
            },
            { root: true }
          );
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.error,
            },
            { root: true }
          );
        }
        this.context.commit("SetInsertPndLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoGetPndDetailById(input: any) {
    if (this.pndDetailByIdLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetPndDetailByIdLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      API.PndService.GetPndByIdModel(input).then((res) => {
        const pndDetailById = ConvertToPndDetailById(res.data.data);
        this.context.commit("SetPndDetailById", pndDetailById);

        this.context.dispatch("Loading/IsLoading", false, { root: true });
        this.context.commit("SetPndDetailByIdLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoUpdatePnd(input: any) {
    if (this.updatePndLoadingstatus !== LoadingStatusType.Loading) {
      const updatePnd = ConvertToInsertPnd(input);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetUpdatePndLoadingstatus", LoadingStatusType.Loading);
      API.PndService.UpdatePnd(updatePnd).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          let linkName = "";
          let linkDetailName = "";
          let pndType = 0;
          let alertMessage = "";

          switch (input.pndType) {
            case PndType.PND1:
              linkName = "pnd1";
              linkDetailName = "pnd1Detail";
              alertMessage = "Updated_PND1_Success";
              pndType = PndType.PND1;
              break;
            case PndType.PND2:
              linkName = "pnd2";
              linkDetailName = "pnd2Detail";
              alertMessage = "Updated_PND2_Success";
              pndType = PndType.PND2;
              break;
            case PndType.PND3:
              linkName = "pnd3";
              linkDetailName = "pnd3Detail";
              alertMessage = "Updated_PND3_Success";
              pndType = PndType.PND3;
              break;
            case PndType.PND53:
              linkName = "pnd53";
              linkDetailName = "pnd53Detail";
              alertMessage = "Updated_PND53_Success";
              pndType = PndType.PND53;
              break;
          }

          if (input.status < PndStatus.AwaitFiling) {
            router.push({
              name: linkName,
              query: { emi: MerchantId().PeakEncryption(), epti: btoa(pndType.toString()) },
            });
          } else {
            router.push({
              name: linkDetailName,
              query: {
                emi: MerchantId().PeakEncryption(),
                epti: btoa(pndType.toString()),
                epi: btoa(res.data.data.id.toString()),
              },
            });
          }
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t(alertMessage, { msg: res.data.data.pndNumber }),
              typeMessage: TypeComponentNoti.success,
            },
            { root: true }
          );
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.error,
            },
            { root: true }
          );
        }
        this.context.commit("SetUpdatePndLoadingstatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoVoidPnd(input: any) {
    if (this.voidPndLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetVoidPndLoadingStatus", LoadingStatusType.Loading);
      const pndByIdOption = {
        pndId: input.pndId,
        pndType: input.pndType,
      };
      API.PndService.VoidPnd(pndByIdOption).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          let linkName = "";
          let alertMessage = "";
          switch (input.pndType) {
            case PndType.PND1:
              linkName = "pnd1";
              alertMessage = "Voided_PND1_Success";
              break;
            case PndType.PND2:
              linkName = "pnd2";
              alertMessage = "Voided_PND2_Success";
              break;
            case PndType.PND3:
              linkName = "pnd3";
              alertMessage = "Voided_PND3_Success";
              break;
            case PndType.PND53:
              linkName = "pnd53";
              alertMessage = "Voided_PND53_Success";
              break;
          }
          router.push({
            name: linkName,
            query: {
              emi: MerchantId().PeakEncryption(),
              epti: btoa(input.pndType.toString()),
              stid: PndTableViewStatusType.Voided.toString(),
            },
          });
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t(alertMessage, { msg: res.data.data.pndNumber }),
              typeMessage: TypeComponentNoti.success,
            },
            { root: true }
          );
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.error,
            },
            { root: true }
          );
        }
        this.context.commit("SetVoidPndLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }

  @Action
  public DoGetIsFiledPnd(input: any) {
    if (this.isFiledPndModelFromMongoLoadingStatus !== LoadingStatusType.Loading) {
      const data = {
        pndId: input.pndId,
        pndType: input.pndType,
      };
      this.context.commit("SetIsFiledPndModelFromMongoLoadingStatus", LoadingStatusType.Loading);
      API.PndService.GetIsFiledPndModel(data).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("SetIsFiledPndModelFromMongoDetail", res.data.data);
          this.context.commit("SetIsFiledPndModelFromMongoLoadingStatus", LoadingStatusType.Success);
        }
      });
    }
  }

  @Action
  public DoUpdateIsFiledPndByPrintForm(input: any) {
    if (this.updateIsFiledPndLoadingStatus !== LoadingStatusType.Loading) {
      let transactionType = TransactionType.None;
      let urlName = "";
      let url = "";
      switch (input.pndType) {
        case PndType.PND1:
          transactionType = TransactionType.Pnd1;
          urlName = "pnd1";
          break;
        case PndType.PND2:
          transactionType = TransactionType.Pnd2;
          urlName = "pnd2";
          break;
        case PndType.PND3:
          transactionType = TransactionType.Pnd3;
          urlName = "pnd3";
          break;
        case PndType.PND53:
          transactionType = TransactionType.Pnd53;
          urlName = "pnd53";
          break;
      }

      url = `${
        process.env.VUE_APP_PeakDocument
      }${urlName}?emi=${MerchantId().PeakEncryption()}&eti=${input.pndId.PeakEncryption()}&etti=${transactionType.PeakEncryption()}`;

      window.open(url);

      const pndUpdateIsFiledOption = ConvertToUpdateIsFiledPnd(input, url);
      this.context.commit("SetUpdateIsFiledPndLoadingStatus", LoadingStatusType.Loading);
      API.PndService.UpdateIsFiledPnd(pndUpdateIsFiledOption).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Filing_Tax_Form_Success", { msg: input.pndNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
          this.context.commit("SetPndDetailByIdLoadingStatus", LoadingStatusType.None);
          this.context.commit("SetIsFiledPndModelFromMongoLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetUpdateIsFiledPndLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoUpdateIsFiledPndByDownloadFileText(input: any) {
    if (this.updateIsFiledPndLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetUpdateIsFiledPndLoadingStatus", LoadingStatusType.Loading);
      const fileTextOption = {
        pndId: input.pndId,
        pndType: input.pndType,
      };
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      API.PndService.GetPndTextFile(fileTextOption).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          DownloadFileFormUrl(res.data.data.fileUrl, res.data.data.fileName);
          const pndUpdateIsFiledOption = ConvertToUpdateIsFiledPnd(input, res.data.data.fileUrl);
          API.PndService.UpdateIsFiledPnd(pndUpdateIsFiledOption).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Filing_Tax_Form_Success", { msg: input.pndNumber }),
                  typeMessage: TypeComponentNoti.Success,
                },
                { root: true }
              );
              this.context.commit("SetPndDetailByIdLoadingStatus", LoadingStatusType.None);
              this.context.commit("SetIsFiledPndModelFromMongoLoadingStatus", LoadingStatusType.None);
            } else {
              const alertMessage = GetMessageExceptionCode(res.data.exception);
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: alertMessage,
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
            }
            this.context.commit("SetUpdateIsFiledPndLoadingStatus", LoadingStatusType.Success);
            this.context.dispatch("Loading/IsLoading", false, { root: true });
            this.context.commit("SetIsOpenModalCheckTextFileForFiledPnd", false);
          });
        } else if (
          res.data.exception.exceptionCode === ExceptionCode.PndError &&
          res.data.exception.errorCode === PndErrorCode.CheckTheDataPositioningInTextFile
        ) {
          this.context.commit("SetIsOpenModalCheckTextFileForFiledPnd", true);
          this.context.commit("SetUpdateIsFiledPndLoadingStatus", LoadingStatusType.None);
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        }
      });
    }
  }

  @Action
  public DoVoidIsFiledPnd(input: any) {
    if (this.updateIsFiledPndLoadingStatus !== LoadingStatusType.Loading) {
      const pndUpdateIsFiledOption = ConvertToUpdateIsFiledPnd(input, "");
      this.context.commit("SetUpdateIsFiledPndLoadingStatus", LoadingStatusType.Loading);
      API.PndService.UpdateIsFiledPnd(pndUpdateIsFiledOption).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Cancel_Filed_Success", { msg: input.pndNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
          this.context.commit("SetPndDetailByIdLoadingStatus", LoadingStatusType.None);
          this.context.commit("SetIsFiledPndModelFromMongoLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetUpdateIsFiledPndLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoUpdateIsPaidPnd(input: any) {
    if (this.updateIsPaidPndLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetUpdateIsPaidPndLoadingStatus", LoadingStatusType.Loading);
      API.PndService.UpdateIsPaidPnd(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: input.isPaid
                ? i18n.t("Payment_Tax_Success", { msg: input.pndNumber })
                : i18n.t("Cancel_Payment_Tax_Success", { msg: input.pndNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );

          this.context.commit("SetPndDetailByIdLoadingStatus", LoadingStatusType.None);
          this.context.commit("SetIsFiledPndModelFromMongoLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }

        this.context.commit("SetUpdateIsPaidPndLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoUpdateIsClosingEntryPnd(input: any) {
    if (this.updateIsClosingEntryPndLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetUpdateIsClosingEntryPndLoadingStatus", LoadingStatusType.Loading);
      const isClosingEntryPndOption = {
        pndId: input.pndId,
        pndType: input.pndType,
        isClosingEntry: input.isClosingEntry,
        journalDate: input.journalDate,
        language: input.language,
      };
      API.PndService.DoUpdateIsClosingEntryPnd(isClosingEntryPndOption).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Record_Closing_Tax_Success", { msg: input.pndNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
          this.context.commit("SetPndDetailByIdLoadingStatus", LoadingStatusType.None);
          this.context.commit("SetClosingEntryPndModelFromMongoLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetUpdateIsClosingEntryPndLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoCreateExpenseByIsClosingEntryPnd(input: any) {
    if (this.createExpenseByIsClosingEntryPndLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetCreateExpenseByIsClosingEntryPndLoadingStatus", LoadingStatusType.Loading);
      API.PndService.CreateExpenseByIsClosingEntryPnd(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Record_Payment_Success", { msg: input.pndNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
          this.context.commit("SetClosingEntryPndModelFromMongoLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetCreateExpenseByIsClosingEntryPndLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetClosingEntryPndModelFromMongo(input: any) {
    if (this.closingEntryPndModelFromMongoLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetClosingEntryPndModelFromMongoLoadingStatus", LoadingStatusType.Loading);
      API.PndService.GetClosingEntryPndModelFromMongo(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const closingEntryPndModelFromMongo = ConvertToClosingEntryPndModelFromMongo(res.data.data);
          this.context.commit("SetClosingEntryPndModelFromMongo", closingEntryPndModelFromMongo);
        }
        this.context.commit("SetClosingEntryPndModelFromMongoLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoDownloadPndTextFile(input: any) {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    API.PndService.GetPndTextFile(input).then((res) => {
      if (res.data.responseCode.IsSuccess()) {
        DownloadFileFormUrl(res.data.data.fileUrl, res.data.data.fileName);
      }
      this.context.dispatch("Loading/IsLoading", false, { root: true });
    });
  }

  @Action
  public DoVoidIsClosingEntryPndJournal(input: any) {
    if (this.voidIsClosingEntryPndJournalLoadingStatusType !== LoadingStatusType.Loading) {
      this.context.commit("SetVoidIsClosingEntryPndJournalLoadingStatusType", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      API.PndService.VoidIsClosingEntryPndJournal(input.data).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Void_Record_Account_Success", { number: input.journalNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
          this.context.commit("SetPndDetailByIdLoadingStatus", LoadingStatusType.None);
          this.context.commit("SetClosingEntryPndModelFromMongoLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetVoidIsClosingEntryPndJournalLoadingStatusType", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoVoidIsClosingEntryPndExpense(input: any) {
    if (this.voidIsClosingEntryPndExpenseLoadingStatusType !== LoadingStatusType.Loading) {
      this.context.commit("SetVoidIsClosingEntryPndExpenseLoadingStatusType", LoadingStatusType.Loading);
      API.PndService.VoidIsClosingEntryPndExpense(input.data).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Void_Record_Payment_Tax_Success", { number: input.expenseNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
          this.context.commit("SetClosingEntryPndModelFromMongoLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetVoidIsClosingEntryPndExpenseLoadingStatusType", LoadingStatusType.Success);
      });
    }
  }
}
